export const getEnv = (field) => {
  if (!field || typeof field !== "string") return undefined;

  return field
    .split(".")
    .reduce((obj, key) => (obj && obj[key] !== undefined ? obj[key] : undefined), window._env_);
};
